import React from 'react';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
export function App() {
  return <Layout data-id="element-0">
      <Home data-id="element-1" />
    </Layout>;
}